mutation TakeSceneLive($eventId: ID!, $overlayId: ID!, $sceneId: ID!, $transition: String) {
  overlay: StreamToolsTakeSceneLive(eventId: $eventId, overlayId: $overlayId, sceneId: $sceneId, transition: $transition) {
    overlayId
    eventId
    kind
    name
    width
    height
    liveSceneId
    liveScene {
      sceneId
      name
      sourceVersion
      takenAt
      elements {
        elementKind
        elementId
        x
        y
        z
        scale
        visible
        w
        h
      }
    }
    sceneOrder
    version
    createdAt
  }
}
